/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Vacation } from '../models/Vacation';
import type { VacationListResponse } from '../models/VacationListResponse';
import type { VacationRequest } from '../models/VacationRequest';
import { request as __request } from '../core/request';

export class VacationsService {

    /**
     * List all vacations for a company within a date range
     * @returns VacationListResponse Vacations within the given range
     * @throws ApiError
     */
    public static async getVacations({
companyId,
startDate,
endDate,
}: {
companyId: number,
startDate: string,
endDate: string,
}): Promise<VacationListResponse> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/vacations`,
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Invalid request (missing startDate/endDate)`,
            },
        });
        return result.body;
    }

    /**
     * Create vacation(s) for an employee
     * Accepts either a single `date`, or a `startDate`/`endDate` range (inclusive), which is expanded into one vacation row per day.
 * 
     * @returns VacationListResponse Vacation(s) created
     * @throws ApiError
     */
    public static async addVacations({
companyId,
requestBody,
}: {
companyId: number,
requestBody: VacationRequest,
}): Promise<VacationListResponse> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/vacations`,
            body: requestBody,
            errors: {
                400: `Invalid request (e.g. missing employeeId/date, or range without both start and end)`,
            },
        });
        return result.body;
    }

    /**
     * Update an existing vacation
     * @returns Vacation Vacation updated
     * @throws ApiError
     */
    public static async updateVacations({
companyId,
vacationId,
requestBody,
}: {
companyId: number,
vacationId: number,
requestBody: VacationRequest,
}): Promise<Vacation> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/vacations/${vacationId}`,
            body: requestBody,
            errors: {
                400: `Invalid request (e.g. missing id)`,
                404: `Vacation not found`,
            },
        });
        return result.body;
    }

    /**
     * Archive (soft-delete) a vacation
     * @returns any Vacation archived
     * @throws ApiError
     */
    public static async deleteVacations({
companyId,
vacationId,
}: {
companyId: number,
vacationId: number,
}): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/vacations/${vacationId}`,
            errors: {
                404: `Vacation not found`,
            },
        });
        return result.body;
    }

}